import { PropsWithChildren, useCallback, useState } from 'react';
import { ShoppingCartContext } from './context';

const shoppingCartLocalStorageKey = 'shoppingCart';
const initialiseFromLocalStorage = () => {
	const stored = localStorage.getItem(shoppingCartLocalStorageKey);
	if (!stored) {
		return new Map();
	}
	return new Map(JSON.parse(stored));
};

export const ShoppingCartProvider = ({ children }: PropsWithChildren) => {
	const [quantityPerPriceItemId, setQuantityPerPriceItemId] = useState<Map<string, number>>(
		initialiseFromLocalStorage()
	);

	const setQuantity = useCallback((id: string | undefined, quantity: number) => {
		if (!id) return;
		setQuantityPerPriceItemId((prev) => {
			const next = new Map(prev);
			if (quantity > 0) {
				next.set(id, quantity);
			} else {
				next.delete(id);
			}
			localStorage.setItem(shoppingCartLocalStorageKey, JSON.stringify(Array.from(next.entries())));
			return next;
		});
	}, []);

	const clearCart = useCallback(() => {
		setQuantityPerPriceItemId(new Map());
		localStorage.removeItem(shoppingCartLocalStorageKey);
	}, []);

	const totalItemsInCart = Array.from(quantityPerPriceItemId.values()).reduce(
		(acc, val) => acc + val,
		0
	);

	const value = {
		quantityPerPriceItemId,
		totalItemsInCart,
		setQuantity,
		clearCart,
	};

	return <ShoppingCartContext.Provider value={value}>{children}</ShoppingCartContext.Provider>;
};
